var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"key-values p-x-4 p-b-4"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-subtitle"},[_c('i',{staticClass:"icon-expand"}),_c('div',{staticClass:"subtitle"},[_vm._v("Key values")])])
}]

export { render, staticRenderFns }